import React, { useState } from "react";
import useMediaQuery from "hooks/useMediaQuery";
import Button from "assets/svg/Button.svg";
import Skeleton from "components/common/Skeleton";
import styles from "./Lending.module.css";
import Modal from "components/common/Modal";
import { fnLink } from "function/fnLink";

const parkingLot = process.env.PUBLIC_URL + "/svg/parkingLot.svg";
const ready = process.env.PUBLIC_URL + "/svg/ready.svg";

export default function Lending() {
    const [loaded, setLoaded] = useState({ bg: false, btn: false });
    const isMobile = useMediaQuery("(max-width: 1023px)");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const allLoaded = loaded.bg && loaded.btn;

    return (
        <div className={styles.lending}>
            {!allLoaded ? (
                <Skeleton height="400px" />
            ) : (
                <>
                    <img
                        className={styles.parkingLot}
                        src={parkingLot}
                        alt="parkingLot"
                        onLoad={() => setLoaded((prev) => ({ ...prev, bg: true }))}
                    />
                    <div className={styles.overlayTextBox}>
                        <div className={styles.text1}>주차, 편리함을 더하다</div>
                        <div className={styles.text2}>
                            나의 일상에 딱맞는
                            {isMobile && <br />} {/* 📌 모바일이면 줄바꿈 */}
                            스마트 주차 동반자,{" "}
                            <span className={styles.highlight}>Capl</span>
                        </div>
                        <img
                            className={styles.downloadBtn}
                            src={Button}
                            alt="downloadLink"
                            onLoad={() => setLoaded((prev) => ({ ...prev, btn: true }))}
                            // onClick={() => setIsModalOpen(true)}
                            onClick={fnLink}
                        />
                    </div>
                </>
            )}

            {/* 이미지 로딩 감지 (렌더는 안 됨) */}
            <img
                src={parkingLot}
                alt=""
                style={{ display: "none" }}
                onLoad={() => setLoaded((prev) => ({ ...prev, bg: true }))}
            />
            <img
                src={Button}
                alt=""
                style={{ display: "none" }}
                onLoad={() => setLoaded((prev) => ({ ...prev, btn: true }))}
            />

            {/* ✅ 공용 모달 사용 */}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <img src={ready} style={{ width: "48px" }} alt="ready" />
                <p>앱 출시가 얼마 남지 않았어요!</p>
                <p>기대해 주세요 🚗</p>
            </Modal>
        </div>
    );
}
